import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PageContentPreloader, SearchPanel, NoItemsPanel } from 'common/components';

import noPartnersImage from 'common/images/noPartners.svg';
import { PartnershipUsersTable, ClientsBalanceTab } from '..';

const PartnershipClientsBlock = ({
  getPartnershipClientsBalance,
  partnershipClientsBalance,
  partnershipClients,
  viewClientsUserTags,
  partnershipClientsAreLoaded,
  viewEmailPermission,
  viewPhonePermission,
  viewSubIbTreePermission,
  partnershipNetworkBalance,
  location,
  history,
  query,
  getList,
  referType,
}) => {
  useEffect(() => {
    if (partnershipNetworkBalance) {
      getPartnershipClientsBalance();
    }
  }, []);

  return (
    <PageContentPreloader ready={partnershipClientsAreLoaded}>
      {(!!partnershipClients.count || !!Object.keys(query).length) && (
        <SearchPanel
          location={location}
          history={history}
          getList={getList}
          filterName="status"
          params={{ search: query }}
        />
      )}
      {referType !== 'refer_friend' && partnershipNetworkBalance && (
        <ClientsBalanceTab partnershipClientsBalance={partnershipClientsBalance} />
      )}
      {partnershipClients.count ? (
        <PartnershipUsersTable
          data={partnershipClients}
          getList={getList}
          loading={!partnershipClientsAreLoaded}
          location={location}
          history={history}
          params={{ search: query }}
          viewEmailPermission={viewEmailPermission}
          viewPhonePermission={viewPhonePermission}
          viewSubIbTreePermission={viewSubIbTreePermission}
          viewClientsUserTags={viewClientsUserTags}
          referType={referType}
        />
      ) : (
        <NoItemsPanel
          icon={noPartnersImage}
          captionSlug={
            Object.keys(query).length
              ? 'partnershipNoClientsCaptionMatchingTheParameters'
              : 'partnershipNoClientsCaption'
          }
          descriptionSlug={!Object.keys(query).length && 'partnershipNoClientsDescription'}
        />
      )}
    </PageContentPreloader>
  );
};

PartnershipClientsBlock.propTypes = {
  getPartnershipClientsBalance: PropTypes.func,
  partnershipClientsBalance: PropTypes.object,
  partnershipClients: PropTypes.object.isRequired,
  partnershipClientsAreLoaded: PropTypes.bool.isRequired,
  viewEmailPermission: PropTypes.bool.isRequired,
  viewPhonePermission: PropTypes.bool.isRequired,
  viewSubIbTreePermission: PropTypes.bool.isRequired,
  partnershipNetworkBalance: PropTypes.bool.isRequired,
  viewClientsUserTags: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  query: PropTypes.object,
  getList: PropTypes.func.isRequired,
  referType: PropTypes.string,
};

PartnershipClientsBlock.defaultProps = {
  partnershipClientsBalance: null,
  getPartnershipClientsBalance: null,
  query: {},
  referType: 'refer_partner',
};

export default connect(
  state => ({
    partnershipClientsAreLoaded: state.client.partnership.partnershipClientsAreLoaded,
    partnershipClientsBalance: state.client.partnership.partnershipClientsBalance,
    partnershipClients: state.client.partnership.partnershipClients,
    viewDetailsPermission: state.interfaceConfig.partnership.viewDetailsPermission,
    viewEmailPermission: state.interfaceConfig.partnership.viewEmailPermission,
    viewPhonePermission: state.interfaceConfig.partnership.viewPhonePermission,
    viewClientsUserTags: state.interfaceConfig.partnership.viewClientsUserTags,
    viewSubIbTreePermission: state.interfaceConfig.partnership.viewSubIbTreePermission,
    partnershipNetworkBalance: state.interfaceConfig.features.includes('partnershipNetworkBalance'),
  }),
  {}
)(PartnershipClientsBlock);
export { PartnershipClientsBlock };
